import type { FC } from "react";

import { Card, CardRowSimple, type GridCard, Tag, TagIntent } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import style from "../../core/cards/styles/Card.module.scss";

import type { Protein } from "../../../graphql.js";
import { uploaderFieldLabel } from "../../../settings/settings.js";
import { SmartLink } from "../../core/SmartLink.js";
import { getUserDisplayName } from "@/modules/users/utils/user.js";

export interface IProteinCardProps extends GridCard {
  protein: Protein;
  blastContext?: boolean;
}

const ProteinCard: FC<IProteinCardProps> = (props) => {
  const protein: Protein = props.protein;

  if (!protein) {
    return null;
  }

  return (
    <Card key="protein-info-card" title={"Protein Info"}>
      <CardRowSimple
        label={"Sequence ID (accession.version)"}
        value={
          props.blastContext ? (
            <SmartLink to={`/protein/${protein.id}`}>{protein.sequenceId}</SmartLink>
          ) : (
            protein.sequenceId
          )
        }
      />
      {protein.proteinNames && protein.proteinNames.length > 0 && (
        <CardRowSimple label={"Names"}>
          <div className={style.tags_list}>
            {protein.proteinNames.map((name) => (
              <Tag intentColor={TagIntent.Secondary} key={`protein-${name}`}>
                {name}
              </Tag>
            ))}
          </div>
        </CardRowSimple>
      )}
      <CardRowSimple label={"Systematic name"} value={protein.systematicName} />
      <CardRowSimple label={"Alternative name"} value={protein.alternativeName} />
      {protein.species && <CardRowSimple label={"Species"} value={<em>{protein.species.name}</em>} />}
      <CardRowSimple label={"Description"} value={protein.description} />
      <CardRowSimple label={"Note"} value={protein.note} />
      <CardRowSimple
        label={"Molecular weight"}
        value={protein.molecularWeight != null ? `${formatNumberByThousands(protein.molecularWeight)} u` : null}
      />
      <CardRowSimple
        label={"Isoelectric point"}
        value={protein.isoelectricPoint != null ? `pH ${protein.isoelectricPoint}` : null}
      />
      <CardRowSimple label={"Length"} value={formatNumberByThousands(protein.length) + " aa"} />
      <CardRowSimple label={uploaderFieldLabel} value={getUserDisplayName(protein.creator)} />
    </Card>
  );
};

export { ProteinCard };
